import ReportAnIssue from './ReportAnIssue'

export default ReportAnIssue
